import { render } from "./DaftarGaleriDokumen.vue?vue&type=template&id=4573acdb"
import script from "./DaftarGaleriDokumen.vue?vue&type=script&lang=js"
export * from "./DaftarGaleriDokumen.vue?vue&type=script&lang=js"

import "./DaftarGaleriDokumen.vue?vue&type=style&index=0&id=4573acdb&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__